import { Controller } from 'stimulus'
import { jsRequest } from '@react/helpers/fetch'

// Bootstrap 4 cannot stack modals, so this raises the second one (layouts/_stacked_modal).
// Its links sit in the other modal's card, hence the document-level listener.
export default class extends Controller {
  connect() {
    this.modal = this.element.querySelector('.modal')
    this.body  = this.modal.querySelector('[data-target="modal.modal"]')

    $(this.modal).on('show.bs.modal',   () => this._raise())
    $(this.modal).on('hidden.bs.modal', () => this._keepPageLocked())
  }

  open(event) {
    const link = event.target.closest('[data-stacked-modal-route]')
    if (!link) return

    event.preventDefault()
    this.body.innerHTML = this._spinner()
    $(this.modal).modal('show')

    jsRequest(link.dataset.stackedModalRoute, {
      callback:  () => reloadReact(this.modal),
      onFailure: () => $(this.modal).modal('hide')
    })
  }

  // Bootstrap appends the backdrop right after this event, hence the next tick.
  _raise() {
    const below = Array.from(document.querySelectorAll('.modal.show')).filter(modal => modal !== this.modal).pop()
    if (!below) { this.modal.style.zIndex = ''; return }

    const base = parseInt(getComputedStyle(below).zIndex, 10) || 1050
    this.modal.style.zIndex = base + 20

    setTimeout(() => {
      const backdrops = document.querySelectorAll('.modal-backdrop')
      const last      = backdrops[backdrops.length - 1]
      if (backdrops.length > 1 && last) last.style.zIndex = base + 10
    }, 0)
  }

  _keepPageLocked() {
    if (document.querySelector('.modal.show')) document.body.classList.add('modal-open')
  }

  _spinner() {
    return `
      <div class="loading-spinner-container">
        <div id="loading-spinner"></div>
      </div>
    `
  }
}
